import { createFileRoute } from '@tanstack/react-router'

import { TeamTabsPage } from '@/pages/team/TeamTabs.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team',
)({
  component: TeamTabsPage,
})
